import { useState, useEffect, React, useReducer } from 'react';
import { initialstate, myreducer, fetchbygetmethod, fetchbypostmethod, fetchbyputmethod } from '../../Commonfiles/Myreducer';
import Modal from 'react-modal';
import axios from 'axios';


function DSpersonaldetails() { 


    const [mydata, setmydata] = useReducer(myreducer, initialstate);
    const [insertmydata, setinsertmydata] = useReducer(myreducer, initialstate);
    var [selectbankdetail, setselectbankdetail] = useReducer(myreducer, initialstate);
    const [getcountry, setgetcountry] = useState(null);
      const [getcity, setgetcity] = useState(null);
              const [getstate, setgetstate] = useState(null);
              const [getarea, setgetarea] = useState(null);
                 const [selectedStateId, setSelectedStateId] = useState(null);
                 const [localGetCity, setLocalGetCity] = useState(getcity || []);
                 const [localGetArea, setLocalGetArea] = useState(getarea || []);
                 const [selectedCityId, setSelectedCityId] = useState(null);
                 const [selectedAreaId, setSelectedAreaId] = useState(null);
    
    


      async function Getstatesname() {
        await fetch(process.env.REACT_APP_URL + "getstatesname", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          }
        })
          .then((response) => response.json())
          .then((data) => {
            setgetstate(data.recordset);
          })
          .catch((err) => {
            console.log("error", err);
          });
      }


    function getbankdetail() {
            fetchbygetmethod(setselectbankdetail, 'bankdetailselect', {})
            console.log(selectbankdetail);
            
        }
    
     

    async function loaddata() {
        var search = document.getElementById('search').value;
       
        // Ensure fetchbygetmethod is awaited if it's asynchronous
        await fetchbygetmethod(setmydata, 'AdminDSpersonaldetails', { tempid: search });
       // This will log after the data is fetched

       console.log(mydata); 
    }

    async function Insertdata() {

       
var tempid = document.getElementById('search').value;
var ApplicantName = document.getElementById('ApplicantName').value;
var NomineeDob = document.getElementById('NomineeDob').value;
var NomineeName = document.getElementById('NomineeName').value;
var ApplicantDob = document.getElementById('ApplicantDob').value;
var ApplicantGender = document.getElementById('ApplicantGender').value;
//var IsApproved = document.getElementById('IsApproved').value;
var ApplicantGuardionName = document.getElementById('ApplicantGuardionName').value;
var CountryId = document.getElementById('CountryId').value;
var StateId = document.getElementById('StateId').value;
var BranchStateId = document.getElementById('selectbranchstate').value;
var CityId = document.getElementById('CityId').value;
var AreaId = document.getElementById('AreaId').value;
var HouseNo = document.getElementById('HouseNo').value;
var MobileNo = document.getElementById('MobileNo').value;
var Email = document.getElementById('Email').value;
var BankId = document.getElementById('selectbankid').value;
var BranchName = document.getElementById('BranchName').value;
var AccNo = document.getElementById('AccNo').value;
var PanNo = document.getElementById('PanNo').value;
var IFSCNo = document.getElementById('IFSCNo').value;
var AdhaarNo = document.getElementById('AdhaarNo').value;
var ChequeNo = document.getElementById('ChequeNo').value;
var AddPType = document.getElementById('AddPType').value;
var IDPType = document.getElementById('IDPType').value;


//console.log(ApplicantName); 
        
        
       
        // Ensure fetchbygetmethod is awaited if it's asynchronous
        await fetchbypostmethod(setinsertmydata, 'Admininsertdsdetails',
             { 
                tempid: tempid,
                ApplicantName: ApplicantName,
                NomineeDob: NomineeDob,
                NomineeName: NomineeName,
                ApplicantDob: ApplicantDob,
                ApplicantGender: ApplicantGender,
              //  IsApproved: IsApproved,
                ApplicantGuardionName: ApplicantGuardionName,
                CountryId: CountryId,
                StateId: StateId,
                BranchStateId: BranchStateId,
                CityId: CityId,
                AreaId: AreaId,
                HouseNo: HouseNo,
                MobileNo: MobileNo,
                Email: Email,
                BankId: BankId,
                BranchName: BranchName,
                AccNo: AccNo,
                PanNo: PanNo,
                IFSCNo: IFSCNo,
                AdhaarNo: AdhaarNo,
                ChequeNo: ChequeNo,
                AddPType: AddPType,
                IDPType: IDPType });
       // This will log after the data is fetched

       console.log(insertmydata); 
    }

    async function Getcountryname() {
        await fetch(process.env.REACT_APP_URL + "getcountryname", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          }
        })
          .then((response) => response.json())
          .then((data) => {
            setgetcountry(data.recordset);
          })
          .catch((err) => {
            console.log("error", err);
          });
      }



      async function Getstatesname() {
        await fetch(process.env.REACT_APP_URL + "getstatesname", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          }
        })
          .then((response) => response.json())
          .then((data) => {
            setgetstate(data.recordset);
          })
          .catch((err) => {
            console.log("error", err);
          });
      }
    
      async function Getcityname(stateid) {
        if (!stateid) {
          console.log("Invalid state ID:", stateid);
          return; // Don't make the request if the stateid is invalid
        }
    
        await fetch(process.env.REACT_APP_URL + "getcityname?stateid=" + stateid, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          }
        })
          .then((response) => response.json())
          .then((data) => {
            setgetcity(data.recordset);
          })
          .catch((err) => {
            console.log("error", err);
          });
    
        //alert("Selected State ID: " + stateid);
      }


      async function Getareaname(Cityid) {
        if (!Cityid) {
          console.log("Invalid Area ID:", Cityid);
          return; // Don't make the request if the stateid is invalid
        }
    
        await fetch(process.env.REACT_APP_URL + "getareaname?Cityid=" + Cityid, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          }
        })
          .then((response) => response.json())
          .then((data) => {
            setgetcity(data.recordset);
          })
          .catch((err) => {
            console.log("error", err);
          });
    
        //alert("Selected State ID: " + stateid);
      }



    
        useEffect(() => { getbankdetail() ;  }, []) 
  
      useEffect(() => {
        Getcountryname(); // Call the function here
      }, []);
    
      useEffect(() => {
        Getstatesname(); // Call the function here
      }, []);
    
      useEffect(() => {
        Getcityname(); // Call the function here
      }, []);

      useEffect(() => {
        Getareaname(); // Call the function here
      }, []);

       useEffect(() => {
                if (selectedStateId) {
                  console.log("Fetching cities for StateId:", selectedStateId);
                  Getcityname(selectedStateId);
                  setSelectedCityId(""); // Reset city when state changes
                  setLocalGetArea([]); // Reset areas when state changes
                }
              }, [selectedStateId]);
            
              useEffect(() => {
                if (Array.isArray(getcity)) {
                  console.log("City list updated:", getcity);
                  setLocalGetCity(getcity.length > 0 ? getcity : []);
                }
              }, [getcity]);
            
              useEffect(() => {
                if (selectedCityId) {
                  console.log("Fetching areas for CityId:", selectedCityId);
                  Getareaname(selectedCityId);
                  setSelectedAreaId(""); // Reset area when city changes
                }
              }, [selectedCityId]);
            
              useEffect(() => {
                if (Array.isArray(getarea)) {
                  console.log("Area list updated:", getarea);
                  setLocalGetArea(getarea.length > 0 ? getarea : []);
                }
              }, [getarea]);
   
    

    return (
    <div className="content-page">
        <div className="content">
            <div className="">
                <div className="page-header-title">
                    <h4 className="page-title">Update Profile  </h4>

                </div>
            </div>

            <div className="page-content-wrapper ">
                <div className="container">
                   
                 <><div className="row">
                                    <div className="col-sm-12">
                                        <div className="panel panel-primary">
                                            <div className="panel-body">
                                                <h4 className="m-t-0 m-b-30">Search Direct Seller</h4>
                                                <hr width="100%" />
                                                <div className="row">


                                                    <div className="col-sm-6 col-xs-12">

                                                        <div className="m-t-20">
                                                            <form className="" action="#">

                                                                <div className="form-group">
                                                                    <label>Direct Seller ID</label>
                                                                    <input type="text" placeholder="Enter Ds Id" class="form-control" id="search"  />

                                                                  



                                                                </div>



                                                            </form>
                                                        </div>
                                                    </div>
                                                               

                                                               

                                                </div>

                                                <div className="form-group">
                                        <div>

                                        <input type="submit"
                                                            className="btn btn-primary waves-effect waves-light" value='Submit' style={{marginLeft:5}} onClick={loaddata}/>
                                                             
                                        </div>
                                    </div>



                                            </div>

                                        </div>
                                    </div>
                                </div>
                               
                                     {mydata.mypost.length > 0 &&
                                    mydata.mypost.map((row, index) => {
                            return (
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="panel panel-primary">
                                                <div className="panel-body">

                                                    <h4 className="m-t-0 m-b-30 form-control btn btn-primary waves-effect waves-light font-monospace" style={{ backgroundColor:'blue', fontWeight: 700, fontSize: 'large' }}>Joining Details</h4>
                                                    <hr width="100%" />
                                                     
                        
                                                    <div className="row">

                                                        <div className="col-sm-6 col-xs-12">

                                                            <div className="m-t-20">
                                                                <form className="" action="#">
                                                                    <div className="form-group">
                                                                        <label>Awareness No</label>
                                                                        <input type='text' className="form-control" defaultValue={row.AwarenessID }/>
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label>Sponsor No</label>
                                                                        <input type='text' className="form-control" defaultValue={row.SponsorID}/>
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label>Position</label>
                                                                        <input type='text' className="form-control" defaultValue={row.Position} />
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label>Status</label>
                                                                        <input type='text' className="form-control" defaultValue={row.isapproved}/>
                                                                    </div>
                                                                </form>
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-6 col-xs-12">

                                                            <div className="m-t-20">
                                                                <form className="" action="#">
                                                                    <div className="form-group">
                                                                        <label>Awareness Name</label>
                                                                        <input type='text' className="form-control" defaultValue={row.awarenessname}/>
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label>Sponsor Name</label>
                                                                        <input type='text' className="form-control" defaultValue={row.sponsorname}/>
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label>Joining Date</label>
                                                                        <input type='text' className="form-control" defaultValue={row.date} />
                                                                    </div>
                                                                    {/* <div className="form-group">
                                                                        <label>ID Card</label>
                                                                        <label className="form-control">Put ID Card here</label>
                                                                    </div> */}
                                                                </form>
                                                            </div>
                                                        </div>
                                                    </div>
                                                 


                                                    <h4 className="m-t-0 m-b-30 form-control btn btn-primary waves-effect waves-light font-monospace" style={{ fontWeight: 700, fontSize: 'large' }}>Personal Details</h4>
                                                    <hr width="100%" />
                                                   
                                                    <div className="row">
                                                        <div className="col-sm-6 col-xs-12">

                                                            <div className="m-t-20">
                                                                <form className="" action="#">
                                                                    <div className="form-group">
                                                                        <label>Applicant Name</label>
                                                                        <input type='text' id='ApplicantName' className="form-control" defaultValue={row.ApplicantName || ''} />
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label>Applicant DOB</label>
                                                                        <input type='text' id='ApplicantDob' className="form-control" defaultValue={row.ApplicantDob || ''} />
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label>Nominee DOB</label>
                                                                        <input type='text' id='NomineeDob' className="form-control" defaultValue={row.NomineeDob || ''} />
                                                                    </div>
                                                                </form>
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-6 col-xs-12">

                                                            <div className="m-t-20">
                                                                <form className="" action="#">
                                                                    <div className="form-group">
                                                                        <label>Guardian Name</label>
                                                                        <input type='text' id='ApplicantGuardionName' className="form-control" defaultValue={row.ApplicantGuardionName || ''}/>
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label>Nominee Name</label>
                                                                        <input type='text' id='NomineeName' className="form-control" defaultValue={row.NomineeName || ''}/>
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label>Gender</label>
                                                                        <input type='text' id='ApplicantGender' className="form-control" defaultValue={row.applicantgender || ''} />
                                                                    </div>
                                                                </form>
                                                            </div>
                                                        </div>
                                                    </div>
                                                 
                                                    <h4 className="m-t-0 m-b-30 form-control btn btn-primary waves-effect waves-light font-monospace" style={{ fontWeight: 700, fontSize: 'large' }}>Communication Details</h4>
                                                    <hr width="100%" />
                                                  
                                                    <div className="row">
                                                        <div className="col-sm-6 col-xs-12">

                                                            <div className="m-t-20">
                                                                <form className="" action="#">
                                                                    <div className="form-group">
                                                                         <label>Country</label>
                                                                       
                                                                   
                                                                         <select
    className="form-control"
    id="CountryId"
    defaultValue={row.Countryid || ""}
    onChange={(e) => {
        console.log("Selected Country ID:", e.target.value);
    }}
>
<option defaultValue={row.CountryName || "0"} hidden>
        {row.CountryName || "0"}
    </option>
    {Array.isArray(getcountry) && getcountry.length > 0 ? (
        getcountry.map((country) => (
            <option key={country.Countryid} value={country.Countryid}>
                {country.CountryName}
            </option>
        ))
    ) : (
        <option disabled>Loading countries...</option>
    )}
</select>

                                                                   
                                                                   
                                                                   
                                                                   
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label>City</label>
                                                                      



                                                                        
                                                                       
<select
        className="form-control"
        id="CityId"
        value={selectedCityId}
        onChange={(e) => {
          setSelectedCityId(e.target.value);
        //   Getareaname(e.target.value);
        }}
        disabled={!selectedStateId || localGetCity.length === 0} // Use localGetCity to avoid disabling
      >
        <option value="" hidden>{mydata.mypost.CityName || "Select City"}</option>
        {localGetCity?.length > 0 ? (
          localGetCity.map((city) => (
            <option key={city.CityId} value={city.CityId}>
              {city.CityName}
            </option>
          ))
        ) : (
          <option disabled>No cities available</option>
        )}
      </select>
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label>House No</label>
                                                                        <input type='text' id='HouseNo' className="form-control" defaultValue={row.HouseNo || ''}/>
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label>Mobile No</label>
                                                                        <input type='text' id='MobileNo' className="form-control" defaultValue={row.MobileNo || ''}/>
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label>Address Proof Type</label>
                                                                        <input type='text' id='AddPType' className="form-control" defaultValue={row.AddPType || ''}/>
                                                                    </div>
                                                                  

                                                                </form>
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-6 col-xs-12">

                                                            <div className="m-t-20">
                                                                <form className="" action="#">
                                                                    <div className="form-group">
                                                                        <label>State</label>
                                                                       
                                                                        <select
        className="form-control"
        id="StateId"
        value={selectedStateId}
        onChange={(e) => setSelectedStateId(e.target.value)}
      >
        <option value="" hidden>{mydata.mypost.StateName || "Select State"}</option>
        {getstate?.length > 0 ? (
          getstate.map((state) => (
            <option key={state.StateId} value={state.StateId}>
              {state.StateName}
            </option>
          ))
        ) : (
          <option disabled>Loading States...</option>
        )}
      </select>
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label>Area</label>
                                                                       

                                                                      
<select
        className="form-control"
        id="AreaId"
        value={selectedAreaId}
        onChange={(e) => setSelectedAreaId(e.target.value)}
        disabled={!selectedCityId || localGetArea.length === 0}
      >
        <option value="" hidden>Select Area</option>
        {Array.isArray(localGetArea) && localGetArea.length > 0 ? (
          localGetArea.map((area) => (
            <option key={area.AreaId} value={area.AreaId}>
              {area.AreaName}
            </option>
          ))
        ) : (
          <option disabled>No areas available</option>
        )}
      </select>
                                                                 
                                                                   
                                                                   
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label>Email</label>
                                                                        <input type='text' id='Email' className="form-control" defaultValue={row.Email || ''}/>
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label>Phone No. Phone no with STD code.</label>
                                                                        <input type='text' className="form-control" defaultValue={'Put Phone no with STD code. here'} />
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label>ID Proof Type</label>
                                                                        <input type='text' id='IDPType'  className="form-control" defaultValue={row.IDPType || ''}/>
                                                                    </div>
                                                                   
                                                                                                                           </form>
                                                            </div>
                                                        </div>
                                                    </div>
                                             
                                                    <h4 className="m-t-0 m-b-30 form-control btn btn-primary waves-effect waves-light font-monospace" style={{ fontWeight: 700, fontSize: 'large' }}>Bank Details</h4>

                                                    <hr width="100%" />

                                                    <div className="row">
                                                        <div className="col-sm-6 col-xs-12">

                                                            <div className="m-t-20">
                                                                <form className="" action="#">
                                                                    <div className="form-group">
                                                                        <label>Bank Name</label>
                                                                        <div className="form-group">
                                                                        <select
    className="form-control"
    id="selectbankid"
    defaultValue={row.BankId || "0"}
    onChange={(e) => console.log("Selected Bank ID:", e.target.value)}
>
    <option value={row.BankId || "0"} hidden>
        {row.BankName || "0"}
    </option>
    {Array.isArray(selectbankdetail.mypost) && selectbankdetail.mypost.length > 0 ? (
        selectbankdetail.mypost.map((bank, index) => (
            <option key={bank.BankId || index} value={bank.BankId}>
                {bank.BankName}
            </option>
        ))
    ) : (
        <option disabled>Loading banks...</option>
    )}
</select>

</div>

                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label>Branch Name</label>
                                                                        <input type='text' id='BranchName' className="form-control" defaultValue={row.BranchName || ''} />
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label>Account No</label>
                                                                        <input type='text' id='AccNo' className="form-control" defaultValue={row.AccNo || ''}/>
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label>Pan No</label>
                                                                        <input type='text' id='PanNo' className="form-control" defaultValue={row.PanNo || ''}/>
                                                                    </div>
                                                                    
                                                                </form>
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-6 col-xs-12">

                                                            <div className="m-t-20">
                                                                <form className="" action="#">
                                                               


<div className="form-group">
<label>Bank Branch State</label>
                                                                        <select
    className="form-control"
    id="selectbranchstate"
    defaultValue={row.StateName || "0"}
    onChange={(e) => console.log("Selected state ID:", e.target.value)}
>
    <option defaultValue={row.StateName || "0"} hidden>
        {row.StateName || "0"}
    </option>
    {Array.isArray(getstate) && getstate.length > 0 ? (
        getstate.map((state, index) => (
            <option key={state.StateId || index} >
              {state.StateName}
            </option>
        ))
    ) : (
        <option disabled>Loading banks...</option>
    )}
</select>

</div>

                                                                    <div className="form-group">
                                                                        <label>IFSC Code</label>
                                                                        <input type='text' id='IFSCNo' className="form-control" defaultValue={row.IFSCNo || ''}/>
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label>Adhaar No</label>
                                                                        <input type='text' id='AdhaarNo' className="form-control" defaultValue={row.AdhaarNo || ''}/>
                                                                    </div>
                                                                    
                                                                    <div className="form-group">
                                                                        <label>Cheque No.</label>
                                                                        <input type='text' id='ChequeNo' className="form-control" defaultValue={row.ChequeNo || ''}/>
                                                                    </div>
                                                                  
                                                              
                                                                </form>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="form-group">


<div>

    <button type="submit"
        className="btn btn-primary waves-effect waves-light" style={{ marginLeft: 300 }} onClick={Insertdata}>
        Update</button>

</div>




</div>
                                   
                                                 


                                                </div>
                                                {/* <label>Submit Button</label> */}
                                            </div>
                                        </div>
                                        
                                        
                                  
                                  
                                    </div>
                                    
  )

                        })
                    
                    }

                    
                                     
                                    
                                    
                                       
                                  




                                     
                                   </>
                                    

                </div>
            </div>
        </div>
        <footer className="footer"> © 2016 WebAdmin - All Rights
            Reserved. </footer>
    </div>)
}

export default DSpersonaldetails;